/**
 * Unit price override schemas.
 *
 * Admin-set price overrides for EP/OTC trading pairs.
 */
import { z } from 'zod';

/** POST /api/admin/unit-price — create override. */
export const UnitPriceCreateSchema = z.object({
  pair: z.string().min(1).max(32),
  override_price: z.string().min(1).max(30),
  is_active: z.boolean().default(true),
  reason: z.string().max(500).optional(),
});
export type UnitPriceCreateRequest = z.infer<typeof UnitPriceCreateSchema>;

/** PATCH /api/admin/unit-price/:id — update override. */
export const UnitPricePatchSchema = z.object({
  override_price: z.string().min(1).max(30).optional(),
  is_active: z.boolean().optional(),
  reason: z.string().max(500).optional(),
});
export type UnitPricePatchRequest = z.infer<typeof UnitPricePatchSchema>;

/** GET /api/admin/unit-price — list overrides. */
export const UnitPriceListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  pair: z.string().max(32).optional(),
  is_active: z
    .string()
    .optional()
    .transform((v) => (v === 'true' ? true : v === 'false' ? false : undefined)),
});
export type UnitPriceListQuery = z.infer<typeof UnitPriceListQuerySchema>;
